<template>
  <div id="monthly-report">
    <div class="clearfix" />

    <h2>Ежемесячный отчет</h2>

    <div class="left">
      <span class="text-gray margin-right sengine-select-divider">|</span>

      <form
        class="form-inline"
        style="display: inline-block;"
      >
        <client-projects-region-select />
      </form>

      <span class="text-gray margin-right sengine-select-divider">|</span>

      <form
        class="form-inline"
        style="display: inline-block; margin-top: -6px;"
      >
        <c-select
          v-model="year"
          title="ГОД:"
          form-group
          :options="getYearsFormated"
        />
      </form>

      <span class="text-gray margin-left margin-right sengine-select-divider">|</span>

      <form
        class="form-inline"
        style="display: inline-block; margin-top: -6px;"
      >
        <div class="form-group">
          <label class="control-label">МЕСЯЦ:</label>
          <month-select
            v-model="month"
            :year="parseInt(year)"
          />
        </div>
      </form>
    </div>

    <div class="clearfix" />

    <content-links
      class="text-center margin-top"
      :data="links"
    />

    <a name="positions-dynamics" />
    <h3 class="margin-bottom">
      1. Динамика позиций сайта
    </h3>

    <div class="row">
      <div class="col-md-7">
        <priority-dynamics
          :loading="fetching"
          :data="report ? report.ДанныеОтчета.ДанныеПоКатегориямТопа || [] : []"
          :conclusion="report ? report.ДанныеОтчета.ВыводыПоКатегорииТопа || '' : ''"
          :from="report ? report.НачалоПериодаОтчета : ''"
          :to="report ? report.ОкончаниеПериодаОтчета : ''"
        />
      </div>
      <div class="col-md-5">
        <region-dynamics
          :loading="fetching"
          :data="report ? report.ДанныеОтчета.ДанныеПоДинамике || [] : []"
          :conclusion="report ? report.ДанныеОтчета.ВыводыПоДинамике || '' : ''"
          :from="report ? report.НачалоПериодаОтчета : ''"
          :to="report ? report.ОкончаниеПериодаОтчета : ''"
        />
      </div>
    </div>

    <a name="traffic-indicators" />
    <h3 class="margin-bottom">
      2. Показатели трафика сайта
    </h3>

    <div class="row">
      <div class="col-md-8">
        <traffic-per-month
          :loading="fetching"
          :data="report ? report.ДанныеОтчета.ТаблицаТрафикПоМесяцам || [] : []"
        />
      </div>
      <div class="col-md-4">
        <traffic-per-week
          :loading="fetching"
          :data="report ? report.ДанныеОтчета.ТаблицаТрафикПоНеделям || [] : []"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <p
          v-if="report"
          v-html="conclusionHtml(report.ДанныеОтчета.ВыводыПоТрафику || '')"
        />
      </div>
    </div>

    <a name="traffic-structure" />
    <h3 class="margin-bottom">
      3. Структура поискового трафика
    </h3>

    <div class="row">
      <div class="col-md-7">
        <traffic-structure-per-month
          :loading="fetching"
          :data-yandex="report ? report.ДанныеОтчета.ДинамикаЯндекс || [] : []"
          :data-google="report ? report.ДанныеОтчета.ДинамикаГугл || [] : []"
          :data-devices="report? report.ДанныеОтчета.ДинамикаПоПСПоУстройствам || [] : []"
        />
      </div>
      <div class="col-md-5">
        <traffic-structure
          :loading="fetching"
          :data="report ? report.ДанныеОтчета.СтруктураТрафика || [] : []"
          :month="month"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <p
          v-if="report"
          v-html="conclusionHtml(report.ДанныеОтчета.ВыводыПоСтруктуреТрафика || '')"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <a name="search-queries" />
        <h3 class="margin-bottom">
          4. Анализ посещаемости сайта по поисковым запросам
        </h3>

        <visits-by-query
          :loading="fetching"
          :data="report ? report.ДанныеОтчета.ТаблицаПосещаемостиПоФразам || [] : []"
          :conclusion="report ? report.ДанныеОтчета.ВыводыПоПосещаемостиПоФразам || '' : ''"
        />
      </div>
      <div class="col-md-6">
        <a name="search-pages" />
        <h3 class="margin-bottom">
          5. Анализ посещаемости сайта по страницам входа
        </h3>

        <visits-by-url
          :loading="fetching"
          :data="report ? report.ДанныеОтчета.ТаблицаПосещаемостиПоСтраницамВхода || [] : []"
          :conclusion="report ? report.ДанныеОтчета.ВыводыПоПосещаемостиПоСтраницаВхода || '' : ''"
        />
      </div>
    </div>

    <a name="traffic-sources" />
    <h3 class="margin-bottom">
      6. Источники трафика
    </h3>

    <div class="row">
      <div class="col-md-5">
        <traffic-sources
          :loading="fetching"
          :data="report ? report.ДанныеОтчета.ТаблицаДиаграммыИсточниковТрафика || [] : []"
          :month="month"
          :conclusion="report ? report.ДанныеОтчета.ВыводыПоИсточникамТрафика || '' : ''"
        />
      </div>
      <div class="col-md-7">
        <traffic-sources-per-month
          :loading="fetching"
          :data="report ? report.ДанныеОтчета.ТаблицаГрафикаИсточниковТрафика || [] : []"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <a name="devices" />
        <h3 class="margin-bottom">
          7. Устройства входа
        </h3>

        <traffic-devices
          :loading="fetching"
          :data="report ? report.ДанныеОтчета.ТаблицаУстройстваВхода || [] : []"
          :conclusion="report ? report.ДанныеОтчета.ВыводыПоУстройствамВхода || '' : ''"
        />
      </div>

      <div class="col-md-6">
        <a name="geo" />
        <h3 class="margin-bottom">
          8. География
        </h3>

        <traffic-geo
          :loading="fetching"
          :data="report ? report.ДанныеОтчета.ТаблицаГеографияКратко || [] : []"
          :conclusion="report ? report.ДанныеОтчета.ВыводыПоГеографии || '' : ''"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <a name="goals" />
        <h3 class="margin-bottom">
          9. Достижение целей
        </h3>

        <traffic-goals
          :loading="fetching"
          :data-table="report ? report.ДанныеОтчета.ТаблицаДостиженийЗаМесяц || [] : []"
          :data-chart="report ? report.ДанныеОтчета.ТаблицаДостиженийЗаГод || [] : []"
          :conclusion="report ? report.ДанныеОтчета.ВыводыПоДостижениям || '' : ''"
          :month="month"
        />
      </div>

      <div class="col-md-6">
        <a name="demographics" />
        <h3 class="margin-bottom">
          10. Демография
        </h3>

        <traffic-demographics
          :loading="fetching"
          :data-age="report ? report.ДанныеОтчета.ТаблицаДемографияВозраст || [] : []"
          :data-gender="report ? report.ДанныеОтчета.ТаблицаДемографияПол || [] : []"
          :conclusion="report ? report.ДанныеОтчета.ВыводыПоДемографии || '' : ''"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <a name="dynamic-works" />
        <h3 class="margin-bottom">
          11. Работы по проекту
        </h3>

        <dynamic-works
          :loading="fetching"
          :data="report ? report.ДанныеОтчета.ДинамическиеРаботы || [] : []"
        />
      </div>

      <div class="col-md-6">
        <a name="regular-works" />
        <h3 class="margin-bottom">
          12. Работы по улучшению результатов продвижения
        </h3>

        <regular-works
          :loading="fetching"
          :data="report ? report.ДанныеОтчета.ПостоянныеРаботы || {} : {}"
        />
      </div>
    </div>

    <a
      v-if="reports.length"
      :href="joinImpersonate(joinClientId(reports[0].link))"
      class="btn btn-success"
      title="Скачать отчет в формате Microsoft Office"
    >
      <i
        class="fa fa-file-word-o"
      /> Скачать
    </a>
  </div>
</template>

<script>
import CSelect from '../../../../../../resources/js/components/ui/CSelect.vue'
import MonthSelect from '../components/MonthlyReport/MonthSelect.vue'
import { getYearsFormated, conclusion1CToHtml, handleClientProjectsSelectedRegionChange, joinClientId, joinImpersonate, getLatestMonthlyReportDate } from '../../../../../../resources/js/helper'
import sengine from '../../../../../../resources/js/mixins/sengine'
import moment from 'moment'
import apiService from '../apiService'
import Notification from '../../../../../../resources/js/notification'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import PriorityDynamics from '../components/MonthlyReport/PriorityDynamics.vue'
import RegionDynamics from '../components/MonthlyReport/RegionDynamics.vue'
import TrafficPerMonth from '../components/MonthlyReport/TrafficPerMonth.vue'
import TrafficPerWeek from '../components/MonthlyReport/TrafficPerWeek.vue'
import ClientProjectsRegionSelect from '../components/ClientProjectsRegionSelect'
import TrafficStructurePerMonth from '../components/MonthlyReport/TrafficStructurePerMonth.vue'
import TrafficStructure from '../components/MonthlyReport/TrafficStructure.vue'
import VisitsByUrl from '../components/MonthlyReport/VisitsByUrl.vue'
import TrafficSources from '../components/MonthlyReport/TrafficSources.vue'
import TrafficSourcesPerMonth from '../components/MonthlyReport/TrafficSourcesPerMonth.vue'
import VisitsByQuery from '../components/MonthlyReport/VisitsByQuery.vue'
import TrafficDevices from '../components/MonthlyReport/TrafficDevices.vue'
import TrafficGeo from '../components/MonthlyReport/TrafficGeo.vue'
import TrafficGoals from '../components/MonthlyReport/TrafficGoals.vue'
import TrafficDemographics from '../components/MonthlyReport/TrafficDemographics.vue'
import DynamicWorks from '../components/MonthlyReport/DynamicWorks.vue'
import RegularWorks from '../components/MonthlyReport/RegularWorks.vue'
import ContentLinks from '../../../../../../resources/js/components/ContentLinks.vue'
import { TYPE_EVERY_MONTH_REPORTS } from '../store/modules/documents'

export default {
  name: 'MonthlyReport',
  components: { ContentLinks, RegularWorks, DynamicWorks, TrafficDemographics, TrafficGoals, TrafficGeo, TrafficDevices, VisitsByQuery, TrafficSourcesPerMonth, TrafficSources, VisitsByUrl, TrafficStructure, TrafficStructurePerMonth, ClientProjectsRegionSelect, TrafficPerWeek, TrafficPerMonth, RegionDynamics, PriorityDynamics, CSelect, MonthSelect },
  mixins: [sengine],
  data () {
    return {
      year: getLatestMonthlyReportDate().format('YYYY'),
      month: getLatestMonthlyReportDate().month(),
      fetching: true,
      report: undefined,
      links: [
        {
          href: 'positions-dynamics',
          title: 'Динамика позиций сайта'
        },
        {
          href: 'traffic-indicators',
          title: 'Показатели трафика сайта'
        },
        {
          href: 'traffic-structure',
          title: 'Структура поискового трафика'
        },
        {
          href: 'search-queries',
          title: 'Анализ посещаемости по запросам'
        },
        {
          href: 'search-pages',
          title: 'Анализ посещаемости по страницам входа'
        },
        {
          href: 'traffic-sources',
          title: 'Источники трафика'
        },
        {
          href: 'devices',
          title: 'Устройства входа'
        },
        {
          href: 'geo',
          title: 'География'
        },
        {
          href: 'goals',
          title: 'Достижение целей'
        },
        {
          href: 'demographics',
          title: 'Демография'
        },
        {
          href: 'dynamic-works',
          title: 'Работы по проекту'
        },
        {
          href: 'regular-works',
          title: 'Работы по улучшению результатов'
        }
      ]
    }
  },
  computed: {
    getYearsFormated () {
      return this.clientProjectsSelectedProjectId ? getYearsFormated(this.getSelectedProject.work_start_date, getLatestMonthlyReportDate()) : []
    },
    ...mapState({
      domainSelected: state => state.seo.client.domains.selected,
      clientProjectsSelectedProjectId: state => state.seo.client.projects.selectedProjectId,
      selectedRegion: state => state.seo.client.projects.selectedRegion,
      reports: state => state.seo.documents.everyMonthReports
    }),
    ...mapGetters({
      getSelectedProject: 'seo/client/projects/getSelectedProject'
    })
  },
  watch: {
    year () {
      this.fetch()
      this.fetchReports()
    },
    month () {
      this.fetch()
      this.fetchReports()
    }
  },
  mounted () {
    if (this.domainSelected) {
      this.fetch()
      this.fetchReports()
    }
    this.$root.$on('clientDomainsSelectedChange', this.fetch)
    this.$root.$on('clientDomainsSelectedChange', this.fetchReports)
    this.$root.$on('clientProjectsSelectedRegionChange', handleClientProjectsSelectedRegionChange)
    this.$root.$on('clientProjectsSelectedRegionChange', this.handleRegionChange)
  },
  destroyed () {
    this.$root.$off('clientDomainsSelectedChange', this.fetch)
    this.$root.$off('clientDomainsSelectedChange', this.fetchReports)
    this.$root.$off('clientProjectsSelectedRegionChange', handleClientProjectsSelectedRegionChange)
    this.$root.$off('clientProjectsSelectedRegionChange', this.handleRegionChange)
  },
  methods: {
    fetch () {
      this.fetching = true

      apiService.getReport(this.domainSelected, this.year, this.month + 1)
        .then(response => {
          this.report = response.data[0]

          if (!this.selectedRegion && this.report) {
            const mainRegion = (this.report.РегионыПродвижения || []).find(value => value.ЭтоОсновной)

            if (mainRegion) {
              this.setClientProjectsSelectedRegion(mainRegion.РегионПродвижения)
            }
          }
        })
        .catch(() => {
          Notification.notifyError({
            title: 'Ошибка',
            content: 'Не удалось загрузить ежемесячный отчет.'
          })
        })
        .finally(() => {
          this.fetching = false
        })
    },
    conclusionHtml (conclusion) {
      return conclusion1CToHtml(conclusion)
    },
    fetchReports () {
      this.fetchClientExportReportsList({
        domain: this.domainSelected,
        type: TYPE_EVERY_MONTH_REPORTS,
        from: moment({ year: this.year, month: this.month, day: 1 }),
        to: moment({ year: this.year, month: this.month, day: 1 }).endOf('month')
      })
    },
    handleRegionChange () {
      if (!Object.values(this.getYearsFormated).includes(this.year)) {
        this.year = Object.values(this.getYearsFormated)[0]
      }
    },
    joinClientId (link) { return joinClientId(link) },
    joinImpersonate (url) { return joinImpersonate(url) },
    ...mapMutations({
      setClientProjectsSelectedRegion: 'seo/client/projects/setSelectedRegion'
    }),
    ...mapActions({
      fetchClientExportReportsList: 'seo/documents/fetch'
    })
  }
}
</script>

<style lang="scss" scoped>
@import "./resources/css/_variables.scss";

h2 {
  float: left;
  margin-right: 20px;

  @media (max-width: $smBreakpoint) {
    float: none;
  }
}

.left {
  margin-top: 22px;
  float: left;

  @media (max-width: $smBreakpoint) {
    margin-top: 0;
    margin-bottom: 15px;
  }

  @media (max-width: $smBreakpoint) {
    margin-right: 0;
    float: none;
  }

  .sengine-select-divider {
    @media (max-width: $smBreakpoint) {
      display: none;
    }
  }
}

h3 {
  background-color: #f2e9ee;
  padding-left: 20px;
  padding-top: 5px;
  padding-bottom: 5px;
  border-left: 3px solid #d71c39;
}
</style>

<style>
  /* глобальные стили */
  #monthly-report .box {
    overflow-x: auto;
  }
</style>
